import { httpClient } from '@/shared/api/httpClient';
import {
  CertificateRequest,
  CertificateRequestSummary,
  IncidentLocation,
  Page,
} from '@/shared/types/certificate-request';

export interface DraftInput {
  incidentType?: string | null;
  incidentDate?: string | null;
  incidentTime?: string | null;
  description?: string;
  location?: IncidentLocation;
}

export const certificateRequestApi = {
  async openDraft(): Promise<CertificateRequest> {
    const { data } = await httpClient.post<CertificateRequest>('/requests');
    return data;
  },

  async saveDraft(id: string, input: DraftInput): Promise<CertificateRequest> {
    const { data } = await httpClient.patch<CertificateRequest>(`/requests/${id}`, input);
    return data;
  },

  async submit(id: string): Promise<CertificateRequest> {
    const { data } = await httpClient.post<CertificateRequest>(`/requests/${id}/submit`);
    return data;
  },

  async discard(id: string): Promise<void> {
    await httpClient.delete(`/requests/${id}`);
  },

  async list(page = 1): Promise<Page<CertificateRequestSummary>> {
    const { data } = await httpClient.get<Page<CertificateRequestSummary>>('/requests', {
      params: { page },
    });
    return data;
  },

  async getById(id: string): Promise<CertificateRequest> {
    const { data } = await httpClient.get<CertificateRequest>(`/requests/${id}`);
    return data;
  },

  /** Só existe depois que a certidão é emitida — a API devolve 404 antes disso. */
  async downloadCertificatePdf(id: string): Promise<Blob> {
    const { data } = await httpClient.get<Blob>(`/requests/${id}/certificate/pdf`, {
      responseType: 'blob',
    });
    return data;
  },
};
